import { render, staticRenderFns } from "./installedApps.vue?vue&type=template&id=232fc7b8&scoped=true"
import script from "./installedApps.vue?vue&type=script&lang=js"
export * from "./installedApps.vue?vue&type=script&lang=js"
import style0 from "./installedApps.vue?vue&type=style&index=0&id=232fc7b8&prod&scoped=true&lang=scss"
import style1 from "./installedApps.vue?vue&type=style&index=1&id=232fc7b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232fc7b8",
  null
  
)

export default component.exports